module.exports = __webpack_public_path__ + "img/nightmares-icon-2.08ffc23b.svg";